var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"auth"}},[_c('keep-alive',[_c('router-view',{key:_vm.$route.path})],1),_c('img',{staticClass:"picture picture--top-right",attrs:{"src":_vm.PICTURE_1}}),_c('img',{staticClass:"picture picture--bottom-left",attrs:{"src":_vm.PICTURE_2}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }